import { render } from "./PortfolioView.vue?vue&type=template&id=897ed502&scoped=true"
import script from "./PortfolioView.vue?vue&type=script&lang=js"
export * from "./PortfolioView.vue?vue&type=script&lang=js"

import "./PortfolioView.vue?vue&type=style&index=0&id=897ed502&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-897ed502"]])

export default __exports__